module.exports = __webpack_public_path__ + "img/6.215c6316.png";